module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded2"
  }, [_c('em', [_vm._v("Dedicated"), _c('br'), _vm._v(" with many thanks to Jim and Jen"), _c('br'), _vm._v(" for their unwitting suggestion of a wonderful plot device"), _c('br'), _vm._v(" and for our amazing Cameron\n            Scott,"), _c('br'), _vm._v(" born 6 October 2008")])]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "ch1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "art",
      "src": "images/Art_Pmap.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbb3c426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SeducedByARogu_dedi-1.vue
// module id = 72
// module chunks = 0